export const globalTheme = {
  outline: "-webkit-focus-ring-color auto 1px", //"1.5px solid rgb(165,199,254)"
  borderRadiusS: "5px",
  borderRadiusM: "10px",
  borderRadiusL: "30px",
  colors: {
    main: "#397ff4",
    secondary: "#f1f1f1",
    textColor: "#6e6e6e",
    white: "white",
    black: "black",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    blue: "#335cda",
    lightOrange: "#fdf4e7",
    orange: "#ee9412",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
  },
  spacing: {
    xxsmall: "0.25rem", // 4px
    xsmall: "0.5rem", // 8px
    small: "0.75rem", // 12px
    medium: "1rem", // 16px
    large: "1.25rem", // 20px
    xlarge: "1.5rem", // 24px
    xxlarge: "2rem", // 32px
    xxxlarge: "2.5rem", // 40px
    xxxxlarge: "3rem", // 48px
  },
  breakpoints: {
    small: "768px",
    medium: "992px",
    large: "1023px",
  },
};
